<template>
  <b-row>
    <b-col cols="9">
      <form-wizard-number />
    </b-col>
    <b-col cols="3">
     <timeline-basic style="overflow: scroll;" :log_pengajuan="berkas.log_pengajuan"/>
    </b-col>
    <b-col cols="12">
      <!-- <div class="d-flex justify-content-center" v-if="berkas.role == 'pembimbing' && berkas.status_sidang_id == 1">
        <div class="mr-1">
          <b-button v-b-modal.modal-center-pembimbing-terima variant="primary">Setuju</b-button>
          <b-modal id="modal-center-pembimbing-terima" centered title="Konfirmasi" :hide-footer="true">
            <center><p>Apakah anda setuju dengan jadwal dan pengajuan sidang skripsi {{berkas.jenis_sidang}}?</p></center>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="success" class="mr-1" @click="terimaBerkas(berkas.role)">Ya</b-button>
                <b-button variant="danger" @click="$bvModal.hide('modal-center-pembimbing-terima')">Tidak</b-button>
            </div>
          </b-modal>
        </div>

        <div>
          <b-button v-b-modal.modal-center-pembimbing-tolak variant="danger">Tidak Setuju</b-button>
          <b-modal id="modal-center-pembimbing-tolak" centered title="Konfirmasi" :hide-footer="true">
            <center><p>Berikan catatan penolakan</p></center>
            <b-form-textarea
              placeholder="Catatan penolakan"
              v-model="catatanPenolakan"
            />
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="success" class="mr-1" @click="tolakBerkas(berkas.role)">Kirim</b-button>
                <b-button variant="danger" @click="$bvModal.hide('modal-center-pembimbing-tolak')">Batal</b-button>
            </div>
          </b-modal>
        </div>
      </div> -->

      <!-- <div class="d-flex justify-content-center" v-if="berkas.role == 'superadmin' && berkas.status_sidang_id == 2">
        <div class="mr-1">
          <b-button v-b-modal.modal-center-pembimbing-terima variant="primary">Setuju</b-button>
          <b-modal id="modal-center-pembimbing-terima" centered title="Konfirmasi" :hide-footer="true">
            <center><p>Apakah anda ya yakin ingin menerima berkas ini?</p></center>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="success" class="mr-1" @click="terimaBerkas(berkas.role)">Ya</b-button>
                <b-button variant="danger" @click="$bvModal.hide('modal-center-pembimbing-terima')">Tidak</b-button>
            </div>
          </b-modal>
        </div>

        <div>
          <b-button v-b-modal.modal-center-pembimbing-tolak variant="danger">Tidak Setuju</b-button>
          <b-modal id="modal-center-pembimbing-tolak" centered title="Konfirmasi" :hide-footer="true">
            <center><p>Berikan catatan perbaikan</p></center>
            <b-form-textarea
              placeholder="Catatan Perbaikan"
              v-model="catatanPenolakan"
            />
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="success" class="mr-1" @click="tolakBerkas(berkas.role)">Kirim</b-button>
                <b-button variant="danger" @click="$bvModal.hide('modal-center-pembimbing-tolak')">Batal</b-button>
            </div>
          </b-modal>
        </div>
      </div> -->
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BButton, BContainer, BFormTextarea } from 'bootstrap-vue'
import FormWizardNumber from './FormWizardNumber.vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  checkExpired,
} from '@/connection-api/auth'
import {
  getPengajuanSidangDetail,
  postTerimaBerkas,
  postTolakBerkas,
} from '@/connection-api/master'
import TimelineBasic from './TimelineBasic.vue'

export default {
  components: {
    BRow,
    BCol,
    FormWizardNumber,
    BButton,
    BContainer,
    BFormTextarea,
    TimelineBasic,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      berkas: {},
      catatanPenolakan: null,
    }
  },

  async mounted() {
    const response = await checkExpired()
    if(response.data.success === true)
    {
      if(response.data.biodata_complete === false)
      {
        this.$router.push({ name: 'pages-account-setting', params: {warning_show: true} })
      }
    }

    const response2 = await getPengajuanSidangDetail(this.$route.params.uuid)
    if(response2.data.success === true)
    {
      this.berkas = response2.data.data
    }
  },
  methods: {
    terimaBerkas(role)
    {
      var data = {
        role: role,
        catatan: this.catatanPenolakan,
        uuid: this.$route.params.uuid,
      }
      postTerimaBerkas(data)
      .then(response => {
        if (response.data.success === true) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan Sidang',
              icon: 'EditIcon',
              variant: 'success',
              text: 'Data berhasil disimpan',
            },
          })
          setTimeout(() => {
            this.$router.push({name: 'list-sidang'})
          }, 1000);
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan Sidang',
              icon: 'EditIcon',
              variant: 'danger',
              text: response.data.message,
            },
          })
          setTimeout(() => {
            this.$router.push({name: 'list-sidang'})
          }, 1000);
        }
      })
      .catch(error => console.log(error));
    },
    tolakBerkas(role)
    {
       var data = {
        role: role,
        catatan: this.catatanPenolakan,
        uuid: this.$route.params.uuid,
      }
      postTolakBerkas(data)
      .then(response => {
        if (response.data.success === true) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan Sidang',
              icon: 'EditIcon',
              variant: 'success',
              text: 'Data berhasil disimpan',
            },
          })
          setTimeout(() => {
            this.$router.push({name: 'list-sidang'})
          }, 1000);
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Pengajuan Sidang',
              icon: 'EditIcon',
              variant: 'danger',
              text: response.data.message,
            },
          })
          setTimeout(() => {
            this.$router.push({name: 'list-sidang'})
          }, 1000);
        }
      })
      .catch(error => console.log(error));
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
